import axios from "@/axios";

export default {
    namespaced: true,
    state: {},

    actions: {
        fetchAll({ commit }) {
            return axios.get('/settings/languages').then(({ data }) => {
                return data
            })
        },

        create({ commit }, { name }) {
            return axios.post('/settings/languages', name, { headers: { 'Content-Type': 'application/json' }}).then(({ data }) => {
                return data
            })
        },

        update({ commit }, { id, name }) {
            return axios.put(`/settings/languages/${id}`,name , { headers: { 'Content-Type': 'application/json' }}).then(({ data }) => {
                return data
            })
        },

        delete({ commit }, { id }) {
            return axios.delete(`/settings/languages/${id}`)
        }
    }
}